import {createFileRoute} from '@tanstack/react-router';
import {StatementConnectedAccountPaymentStatusPage} from 'pages/statements/StatementPaymentStatusPage/StatementConnectedAccountPaymentStatusPage';

export const Route = createFileRoute(
  '/_protected/home/statements/$id/connected-account-payment',
)({
  component: StatementConnectedAccountPaymentStatusPage,
  staticData: {crumbKey: 'navigation.statement.payment'},
});
